import { Award, BarChart2, Users } from "react-feather";


let menuText = localStorage.getItem("menu")
let menuJSON = JSON.parse(menuText)
let menuList = []
if(menuJSON != null){
    let menuEvaluation = menuJSON.filter((item) => item.label == 'Penilaian Pegawai')

    if (menuEvaluation[0] !== undefined) {
        if (menuEvaluation[0].children != undefined || menuEvaluation[0].children != null) {
            menuEvaluation[0].children.map((item) => {
                if(item.label == 'Buku Induk Kepegawaian'){
                    menuList.push({
                        id: "buku-induk",
                        title: "Buku Induk Kepegawaian",
                        navLink: "/hukdis",
                    })
                } else if(item.label == 'Penilaian Individu'){
                    menuList.push({
                        id: "request-individu",
                        title: "Permintaan Individu",
                        navLink: "/permintaan-individu",
                    })
                } else if(item.label == 'Penilaian Kelompok'){
                    menuList.push({
                        id: "request-kelompok",
                        title: "Permintaan Kelompok",
                        navLink: "/permintaan-kelompok",
                    })
                }
            })
        }
    }
}

export default [
    {
        id: "score-work",
        title: "Penilaian Pegawai",
        icon: <Award size={20} />,
        children: menuList
    }
]
